export const ADDRESS_FINDER_INPUT_DESCRIPTION =
  "Please start typing your address or postcode and select your property from the list of results. If we cannot find your property you can choose to enter the details manually.";
